import { render, staticRenderFns } from "./SettingParam.vue?vue&type=template&id=2ad3cdb2&"
import script from "./SettingParam.vue?vue&type=script&lang=js&"
export * from "./SettingParam.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports